import { Component } from "@angular/core";
import {
    IonicPage,
    ToastController,
    PopoverController,
    Popover,
    LoadingController,
    Events,
} from "ionic-angular";
import { pouchdb2 } from "../../services/pouchdb/pouchdb.service";
import { APIOnLine } from "../../services/api/api.services";
import { EstadisticasService } from "../../services/api/estadisticas.service";
import { PaginaBasica } from "../../models/PaginaBase";
import { Proxy } from "../../services/proxy/proxy.service";
import { NuevoMenuDerechoComponent } from "../../components/nuevo-menu-derecho/nuevo-menu-derecho";
import { iConfiguracion } from "../../models/basePage";
import { Online } from "../../models/online/cfutbol";
import { ActasEstadisticas } from "../../models/estadisticas.models";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@IonicPage()
@Component({
    selector: "page-incidencias",
    templateUrl: "incidencias.html",
})
export class IncidenciasPage extends PaginaBasica {
    //#region Propiedades del controlador

    public incidentes: string = ""; // Texto con las incidentes actuales
    public indice: number = undefined; // índice de la incidencia activa

    public designacion: Proxy.PrDesignaciones;
    public idEquipo: number;
    public listaIncidencias: string[] = [];
    public mostrarListaObservaciones: boolean = false; // Indica si debe mostrar la parte de la lista de observaciones disponibles.
    public observacion: Online.IObservacionesEnActa;
    public observaciones: Online.IObservacionesEnActa[] = [];

    public licenciasLocal: Proxy.ListaPrPersonaAlineable;
    public participanteLocal: Proxy.PrParticipacion;
    public participantesLocal: Proxy.ListaPrParticipacion;
    public licenciasVisitante: Proxy.ListaPrPersonaAlineable;
    public participanteVisitante: Proxy.PrParticipacion;
    public participantesVisitante: Proxy.ListaPrParticipacion;

    public tieneEstadisticas: boolean = false;
    public mostrarFormularioEstadisticas: boolean = false;
    public tipoEstadisticaSeleccionada: number;
    public equipoSeleccionado: number;

    //#endregion

    constructor(
        public CFutbolActas: APIOnLine.CFutbolActas,
        public EstadisticasService: EstadisticasService,
        public DBService2: pouchdb2.DBService2,
        public events: Events,
        public loadingCtrl: LoadingController,
        public InformacionEnActaService: APIOnLine.InformacionEnActaService,
        public Persistentes: APIOnLine.Persistentes,
        public popOverCtrl: PopoverController,
        public toastCtrl: ToastController
    ) {
        super(loadingCtrl, toastCtrl);
    }

    ionViewDidEnter() {
        console.log("--- ENTRO EN LA PÁGINA: INCIDENCIAS ---");

        this.designacion = this.Persistentes.GetDesignacion();
        this.idEquipo = this.Persistentes.GetIdEquipo();

        this.Persistentes.GetConfiguracion()
            .then((configuracion: iConfiguracion) => {
                console.log(configuracion);
                this.mostrarListaObservaciones =
                    configuracion.internas.observacionesEnActa;
                this.GenerarIncidencias(this.designacion.OtrosDatos.incidentes); // Genera la lista de incidencias que se han añadido (están separadas por <div></div>)

                if (this.mostrarListaObservaciones) {
                    this.InformacionEnActaService._configuraciones =
                        configuracion;
                    this.InformacionEnActaService.get(
                        configuracion.api.urlAPIs[0].urlApi
                    )
                        .then((resultado: Online.IObservacionesEnActa[]) => {
                            this.observaciones = resultado;
                        })
                        .catch((error) =>
                            this.Error(
                                error,
                                "Obteniendo la lista de posibles observaciones en acta :: " +
                                    JSON.stringify(error)
                            )
                        );
                }

                if (configuracion.internas.estadisticas) {
                    this.tieneEstadisticas = true;
                    this.EstadisticasService.listaPorDesignacion(
                        this.designacion.urlApi,
                        this.designacion.idDesignacion
                    );

                    this.participantesLocal = new Proxy.ListaPrParticipacion(
                        this.CFutbolActas,
                        this.DBService2,
                        this.Persistentes,
                        this.toastCtrl,
                        this.designacion,
                        this.designacion.idLocal
                    );
                    this.licenciasLocal = new Proxy.ListaPrPersonaAlineable(
                        this.CFutbolActas,
                        this.DBService2,
                        this.Persistentes,
                        this.designacion,
                        this.designacion.idLocal
                    );
                    this.participantesVisitante =
                        new Proxy.ListaPrParticipacion(
                            this.CFutbolActas,
                            this.DBService2,
                            this.Persistentes,
                            this.toastCtrl,
                            this.designacion,
                            this.designacion.idVisitante
                        );
                    this.licenciasVisitante = new Proxy.ListaPrPersonaAlineable(
                        this.CFutbolActas,
                        this.DBService2,
                        this.Persistentes,
                        this.designacion,
                        this.designacion.idVisitante
                    );

                    this.participantesLocal
                        .CargarListaParticipacion()
                        .then((resultado: boolean) => {
                            console.log(
                                "Participantes local",
                                this.participantesLocal.lista
                            );
                            return this.licenciasLocal.ObtenerAlineables(
                                true,
                                true,
                                true
                            );
                        })
                        .then((resultado: boolean) => {
                            console.log(
                                "Licencias local",
                                this.licenciasLocal.lista
                            );
                            return this.participantesVisitante.CargarListaParticipacion();
                        })
                        .then((resultado: boolean) => {
                            return this.licenciasVisitante.ObtenerAlineables(
                                true,
                                true,
                                true
                            );
                        })
                        .then((resultado: boolean) => {
                            // Cargar los datos de las estadísticas
                            this.EstadisticasService.listaPorDesignacion(
                                this.designacion.urlApi,
                                this.designacion.idDesignacion
                            );
                        });

                    console.log(
                        "Participantes local",
                        this.participantesLocal.lista
                    );
                }
            })
            .catch((error) =>
                this.Error(
                    error,
                    "Inicializando los datos de la página de Incidencias :: " +
                        JSON.stringify(error)
                )
            );
    }

    //#region Métodos del controlador

    public AbrirMenuSecundario(event: any): void {
        let popover: Popover = this.popOverCtrl.create(
            NuevoMenuDerechoComponent
        );

        popover.present({
            ev: event,
        });
    }

    public ObservacionSeleccionada(event: any): void {
        this.incidentes += this.observacion.contenido;
        this.observacion = undefined;
    }

    /**
     * Convierte un texto en formato HTML a un texto en formato normal.
     * @param html Texto en formato HTML
     * @returns Texto normal
     */
    public ConversionATexto(html: string) {
        // Create a new div element
        var tempDivElement = document.createElement("div");

        // Set the HTML content with the given value
        tempDivElement.innerHTML = html;

        // Retrieve the text property of the element
        return tempDivElement.textContent || tempDivElement.innerText || "";
    }

    /**
     * Procesa el guardado de las incidencias indicadas en la aplicación, separando la información por párrafos.
     */
    public Guardar(): void {
        this.designacion.OtrosDatos.incidentes = "";
        this.designacion.OtrosDatos.urlApi = this.designacion.urlApi;
        this.designacion.OtrosDatos.urlNombre = this.designacion.urlNombre;

        if (this.listaIncidencias.length > 0) {
            this.listaIncidencias.forEach((valor: string) => {
                this.designacion.OtrosDatos.incidentes +=
                    "<div>" + valor + "</div>";
            });
        }

        this.designacion.OtrosDatos.urlApi = this.designacion.urlApi;
        this.designacion.OtrosDatos.urlNombre = this.designacion.urlNombre;

        this.designacion.OtrosDatos.Guardar()
            .then((resultado: boolean) => {
                this.Mensaje("Incidencia guardada correctamente.", 5000);
            })
            .catch((error) =>
                this.Error(
                    error,
                    "ERROR actualizando los datos de la incidencia del acta. "
                )
            );
    }

    //#endregion

    //#region Gestión de la lista de incidenciasNoModificables

    public ActualizarIncidencia(indice: number, _incidentes: string): void {
        this.incidentes = _incidentes;
        this.indice = indice;
    }

    public CancelarActualizacion(): void {
        this.incidentes = "";
        this.indice = undefined;
    }

    public EliminarIncidencia(info: string): void {
        this.listaIncidencias.splice(this.listaIncidencias.indexOf(info), 1);
        this.Guardar();
    }

    private GenerarIncidencias(datos: string): void {
        let aux: string[] = datos.split("</div>");

        this.listaIncidencias = [];

        if (aux.length > 0) {
            aux.forEach((valor: string) => {
                if (valor != "") {
                    this.listaIncidencias.push(valor.replace("<div>", ""));
                }
            });
        }
    }

    public IncluirIncidencia(): void {
        if (this.indice == undefined) {
            this.listaIncidencias.push(this.incidentes);
        } else {
            this.listaIncidencias.splice(this.indice, 1, this.incidentes);
        }
        this.incidentes = "";
        this.Guardar();
    }

    //#endregion

    public getDataFromClipboard(event: ClipboardEvent): void {
        const isIEorEdge = /msie\s|trident\/|edge\//i.test(
            window.navigator.userAgent
        );
        //const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);

        if (isIEorEdge) {
            const data = event.clipboardData || window["clipboardData"];
            const clipboardData = data.getData("text");
            console.log(clipboardData);
            this.incidentes += clipboardData;
        } else {
            navigator["clipboard"].readText().then((data) => {
                console.log(data);
                this.incidentes += data;
            });
        }
    }

    // #region Métodos relacionados con las estadísticas
    
    public EstadisticaEstablecida(tipoEstadistica: number): Observable<boolean> {
        return this.EstadisticasService.estadisticas$.pipe(
            map(estadisticas => estadisticas.some(e => e.tipoEstadistica === tipoEstadistica))
        );
    }

    public EliminarEstadistica(estadistica: ActasEstadisticas): void {
        this.EstadisticasService.eliminar(this.designacion.urlApi, estadistica.id);
    }

    public EstablecerMejorJugador(): void {
        this.tipoEstadisticaSeleccionada = 1; // 1 = Mejor jugador
        this.mostrarFormularioEstadisticas = true;
        this.equipoSeleccionado = undefined;
    }

    public EstablecerJugadorEjemplar(): void {
        this.tipoEstadisticaSeleccionada = 2; // 2 = Jugador ejemplar
        this.mostrarFormularioEstadisticas = true;
        this.equipoSeleccionado = undefined;
    }

    public EstablecerDelegadoEjemplar(): void {
        this.tipoEstadisticaSeleccionada = 3; // 3 = Delegado ejemplar
        this.mostrarFormularioEstadisticas = true;
        this.equipoSeleccionado = undefined;
    }

    public onEquipoSeleccionado(): void {
        // No es necesario hacer nada aquí ya que el cambio se maneja directamente en el template
    }

    public seleccionarParticipante(participante: Proxy.PrParticipacion): void {
        let jugador: Proxy.PrPersonaAlineable = null;

        if (this.equipoSeleccionado == this.designacion.idLocal) {
            jugador = this.licenciasLocal.AlineablePorIdentificador(
                participante.identificador
            );
        } else {
            jugador = this.licenciasVisitante.AlineablePorIdentificador(
                participante.identificador
            );
        }

        const estadistica: ActasEstadisticas = {
            id: 0, // Se asignará en el servidor
            idDesignacion: this.designacion.idDesignacion,
            idCalendario: this.designacion.idCalendario,
            idActa: 0, // No se usa en este contexto
            idEquipo: this.equipoSeleccionado,
            idJugador: participante.idRegistro,
            nombre: jugador.nombre,
            apellido1: jugador.apellido1,
            apellido2: jugador.apellido2,
            dorsal: participante.dorsal,
            estadistica: this.getNombreEstadistica(),
            tipoEstadistica: this.tipoEstadisticaSeleccionada,
        };

        this.EstadisticasService.guardar(this.designacion.urlApi, estadistica);
        this.mostrarFormularioEstadisticas = false;
        this.equipoSeleccionado = undefined;
    }

    private getNombreEstadistica(): string {
        switch (this.tipoEstadisticaSeleccionada) {
            case 1:
                return "Mejor jugador";
            case 2:
                return "Jugador ejemplar";
            case 3:
                return "Delegado ejemplar";
            default:
                return "";
        }
    }

    // #endregion
}



// WEBPACK FOOTER //
// ./src/pages/incidencias/incidencias.ts